import { Component, OnInit } from '@angular/core';
import { AppInformationService, AuthService, GenesisUnitOfWork, UtilityService } from 'app/core/core.module';
import { AchTransaction } from 'app/core/model/entity-model';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
    selector: 'app-bulk-edit-ach-transaction-dialog',
    templateUrl: './bulk-edit-ach-transaction-dialog.component.html',
    styleUrls: ['./bulk-edit-ach-transaction-dialog.component.scss'],
    standalone: false,
})
export class BulkEditAchTransactionDialogComponent implements OnInit {
    result: Subject<any> = new Subject<any>();
    achTransactions: AchTransaction[];
    achTransaction: any;

    constructor(
        public modalRef: BsModalRef,
        private uow: GenesisUnitOfWork,
    ) {}

    async ngOnInit() {
        this.achTransaction = {
            bankConfirmationNumber: '',
            transferInitiated: null,
        };
    }

    async save() {
        if (this.achTransactions && this.achTransactions.length > 0) {
            this.achTransactions.forEach((tx) => {
                tx.bankConfirmationNumber = this.achTransaction.bankConfirmationNumber;
                tx.transferInitiated = this.achTransaction.transferInitiated;
            });
        }

        await this.uow.commit();
        this.result.next({ success: true });
        this.modalRef.hide();
    }

    close() {
        this.result.next({ success: false });
        this.modalRef.hide();
    }
}
